import React from 'react';

const DoctorsMessagePatternTab = ({ className }) => {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" width="100%" height="100%" viewBox="0 0 744 911" fill="none">
      <path d="M413.371 0C524.741 246.95 281.792 512.133 0 372.209V0H413.371Z" fill="#7F4A9B" />
      <path d="M536.846 911C481.035 787.225 602.784 654.31 744 724.443L744 911L536.846 911Z" fill="#7F4A9B" />
    </svg>
  );
};

export default DoctorsMessagePatternTab;